import { add, type Duration, endOfMonth, parseISO } from 'date-fns';

import { PerformanceReviewQuarter, PerformanceReviewVersion } from '../graphql';

export interface PerformanceReviewPeriod {
  year: number;
  quarter: PerformanceReviewQuarter;
}

export class PerformanceReviewUtils {
  static getVersion = (year: number /* , quarter: PerformanceReviewQuarter */) => {
    if (year <= 2025) {
      return PerformanceReviewVersion.Version_1;
    }

    return PerformanceReviewVersion.Version_2;
  };

  static getCurrentPerformanceReviewPeriod = (deltaDuration: Duration = {}): PerformanceReviewPeriod => {
    const today = add(new Date(), deltaDuration);
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    if (month >= 1 && month <= 6) {
      return { year, quarter: PerformanceReviewQuarter.Q1Q2 };
    } else {
      return { year, quarter: PerformanceReviewQuarter.Q3Q4 };
    }
  };

  static isCurrentPerformanceReview = (year: number, quarter: PerformanceReviewQuarter): boolean => {
    const { year: currentYear, quarter: currentQuarter } = PerformanceReviewUtils.getCurrentPerformanceReviewPeriod();
    return currentQuarter === quarter && currentYear === year;
  };

  static periodToString = (value: PerformanceReviewPeriod | null | undefined) => {
    if (value === null || value === undefined) {
      return '';
    }

    return `${value.year} ${PerformanceReviewUtils.quarterToString(value.quarter)}`;
  };

  static periodToDates = (value: PerformanceReviewPeriod | null | undefined) => {
    if (value === null || value === undefined) {
      return null;
    }

    return {
      start: parseISO(`${value.year}-${value.quarter === PerformanceReviewQuarter.Q1Q2 ? '01' : '07'}-01`),
      end: endOfMonth(parseISO(`${value.year}-${value.quarter === PerformanceReviewQuarter.Q1Q2 ? '06' : '12'}-01`)),
    };
  };

  static stringToPeriod = (value: string): PerformanceReviewPeriod => {
    const split = value.split(' ', 2);
    return { year: Number(split[0]), quarter: PerformanceReviewUtils.stringToQuarter(split[1]) };
  };

  static quarterToString = (value: PerformanceReviewQuarter) => value.replace('_', '/');

  static stringToQuarter = (value: string) => value.replace('/', '_') as PerformanceReviewQuarter;

  static getNextPeriod = (value: PerformanceReviewPeriod | null | undefined) => {
    if (!value) return null;

    return {
      year: value.year + (value.quarter === PerformanceReviewQuarter.Q3Q4 ? 1 : 0),
      quarter:
        value.quarter === PerformanceReviewQuarter.Q3Q4 ? PerformanceReviewQuarter.Q1Q2 : PerformanceReviewQuarter.Q3Q4,
    };
  };
}
